"use client";

import { useContext } from "react";

import { WebSocketContext, type WebSocketContextState } from "../../contexts";

/**
 * Provides the websocket context.
 * @see WebSocketProvider
 */
export const useWebSocket = (): WebSocketContextState => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }

  return context;
};
